import { hillo } from 'hillo'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'

const tablePath = 'reservableTable'

export async function getReservationTableList () {
  return (await hillo.get(cloudV2Url + tablePath + '/getList/' + await getCurrentDeviceId(), {})).data
}

export async function getReservationRoomList () {
  return await hillo.get(cloudV2Url + tablePath + '/getRoomList', {})
}

export async function updateCloudReservableTable () {
  await hillo.jsonPost(cloudV2Url + tablePath + '/onNotify/' + await getCurrentDeviceId(), {})
}

export async function saveFiles (file) {
  const filesUrl = []
  for (const item of file) {
    const res = await hillo.postWithUploadFile('https://cloud-v2.aaden.io/uploadFile', {
      file: item
    })
    filesUrl.push(res)
  }
  return filesUrl.join(',')
}

export async function saveFilesWithArr (file) {
  const filesUrl = []
  for (const item of file) {
    if (typeof item !== 'string') {
      const res = await hillo.postWithUploadFile('https://cloud-v2.aaden.io/uploadFile', {
        file: item
      })
      filesUrl.push(res)
    } else {
      filesUrl.push(item)
    }
  }
  return filesUrl
}
